import { convertFullWidthToHalfWidth } from "@/utils/pieces";
import * as wanakana from "wanakana";
import Moji from "moji";

export const handleKatakanaToFurigana = (value: string) => {
  return wanakana.toHiragana(value, { passRomaji: true });
};

export const convertNumberToZipCode = (value: string) => {
  if (!value) return "";

  const cleanedValue = value.replace(/[^\d０-９]/g, "");

  if (cleanedValue.length !== 7) return value;

  return `${cleanedValue.slice(0, 3)}-${cleanedValue.slice(3)}`;
};

export const convertZipCodeToNumber = (zipCode: string) => {
  if (!zipCode) return;
  return zipCode.replace("-", "");
};

export const convertNumberToCommas = (value: string) => {
  if (value) {
    const normalizedValue = convertFullWidthToHalfWidth(value.toString());
    if (/^-?[0-9]+(\.[0-9]*)?$/.test(normalizedValue)) {
      const [integerPart, decimalPart] = normalizedValue?.split(".");
      const formattedIntegerPart = parseInt(integerPart.replace(/,/g, "")).toLocaleString("en-GB");
      return decimalPart !== undefined ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    }
  }
  return value;
};

// Function to convert comma-separated string to plain number
export const convertCommasToNumber = (value: string) => {
  return value.replace(/,/g, "");
};

/**
 * Function to check if a string contains any non-numeric characters
 * including both full-width and half-width characters.
 *z
 * @param {string} input - The input string to validate.
 * @returns {boolean} - Returns true if non-numeric characters are found, otherwise false.
 */
export const containsNonNumeric = (input: string): boolean => {
  const moji = Moji(input);

  // Normalize the string to half-width for consistency
  const normalized = moji.convert("ZE", "HE").toString();

  // Check for non-numeric characters using regex
  const nonNumericRegex = /[^0-9]/; // Only allows half-width numeric digits (0-9)
  return nonNumericRegex.test(normalized);
};
